export default "__VITE_ASSET__31deef89__"